import axios from '@/service/request';
import type { R, PlatformEnum, OrderStatusEnum } from './types';
import type { AxiosRequestConfig } from 'axios';

/**
 * 订单列表请求参数
 */
export interface MiniOrderQueryRequest {
  /** 用户id */
  buyerId?: string;
  /** 平台标识 */
  platform?: PlatformEnum;
  /** 订单状态 */
  status?: OrderStatusEnum;
  /** 查询关键字.订单号或服务名称 */
  keyword?: string;
  /** 每页大小 */
  limit?: number;
  cursor?: {
    createTime: string;
    orderId: string;
  }
}

/**
 * 订单详情响应
 */
export interface OrderDetailResponse {
  /** 订单号 */
  orderNo: string;
  /** 平台标识 */
  platform: PlatformEnum;
  /** 订单标题 */
  title?: string;
  /** 商品摘要（如: SKII ×1, 共5件） */
  productSummary?: string;
  /** 状态 */
  status?: OrderStatusEnum;
  /** 订单金额 */
  amount?: number;
  /** 下单时间 */
  createTime?: string;
  /** 是否支付 */
  isPay?: boolean;
}

/**
 * 分页信息
 */
export interface Pagination {
  /** 是否有下一页 */
  hasMore?: boolean;
  /** 下一个游标数据 */
  nextCursor?: any;
}

/**
 * 订单响应数据
 */
export interface OrderResponse {
  /** 订单列表信息 */
  orderDetails?: OrderDetailResponse[];
  /** 下一页信息 */
  pagination?: Pagination;
}

/**
 * 订单列表
 */
export const apiOrderPage = (data: MiniOrderQueryRequest, config?: AxiosRequestConfig): Promise<R<OrderResponse>> => {
  return axios.post('/order/page', data, config);
};

